/**
 * Grant Functional cookies for “remember me” without dismissing the CMP banner.
 * Call `consent.enableLoginPersistence()` — do not use `acceptSelection` (that closes the banner).
 */
export function grantFunctionalForRememberMe(
  enableLoginPersistence: () => void
): void {
  enableLoginPersistence();
}
